import type { PlatformInfo } from '../types/sync'

// Complete platform registry from backer-ctrl
export const allPlatforms: Record<string, PlatformInfo> = {
  // ========== DYNAMIC PLATFORMS (30) ==========
  DYNAMIC_BILIBILI: {
    type: "DYNAMIC",
    name: "DYNAMIC_BILIBILI",
    homeUrl: "https://t.bilibili.com",
    faviconUrl: "https://static.hdslb.com/images/favicon.ico",
    platformName: "Bilibili",
    injectUrl: "https://t.bilibili.com",
    injectFunction: async () => {},
    tags: ["CN"],
    accountKey: "bilibili",
  },
  DYNAMIC_DOUYIN: {
    type: "DYNAMIC",
    name: "DYNAMIC_DOUYIN",
    homeUrl: "https://creator.douyin.com/",
    faviconUrl: "https://lf1-cdn-tos.bytegoofy.com/goofy/ies/douyin_web/public/favicon.ico",
    platformName: "抖音",
    injectUrl: "https://creator.douyin.com/creator-micro/content/upload?default-tab=3",
    injectFunction: async () => {},
    tags: ["CN"],
    accountKey: "douyin",
  },
  DYNAMIC_X: {
    type: "DYNAMIC",
    name: "DYNAMIC_X",
    homeUrl: "https://x.com/home",
    faviconUrl: "https://x.com/favicon.ico",
    platformName: "X (Twitter)",
    injectUrl: "https://x.com/home",
    injectFunction: async () => {},
    tags: ["International"],
    accountKey: "x",
  },
  DYNAMIC_REDNOTE: {
    type: "DYNAMIC",
    name: "DYNAMIC_REDNOTE",
    homeUrl: "https://creator.xiaohongshu.com/",
    faviconUrl: "https://fe-video-qc.xhscdn.com/fe-platform/ed8fe781ce9e16c1bfac2cd962f0721edabe2e49.ico",
    platformName: "小红书",
    injectUrl: "https://creator.xiaohongshu.com/publish/publish?target=image",
    injectFunction: async () => {},
    tags: ["CN"],
    accountKey: "rednote",
  },
  DYNAMIC_WEIBO: {
    type: "DYNAMIC",
    name: "DYNAMIC_WEIBO",
    homeUrl: "https://weibo.com",
    faviconUrl: "https://weibo.com/favicon.ico",
    platformName: "微博",
    injectUrl: "https://weibo.com",
    injectFunction: async () => {},
    tags: ["CN"],
    accountKey: "weibo",
  },
  DYNAMIC_XUEQIU: {
    type: "DYNAMIC",
    name: "DYNAMIC_XUEQIU",
    homeUrl: "https://xueqiu.com",
    faviconUrl: "https://xueqiu.com/favicon.ico",
    platformName: "雪球",
    injectUrl: "https://xueqiu.com",
    injectFunction: async () => {},
    tags: ["CN"],
    accountKey: "xueqiu",
  },
  DYNAMIC_ZHIHU: {
    type: "DYNAMIC",
    name: "DYNAMIC_ZHIHU",
    homeUrl: "https://www.zhihu.com",
    faviconUrl: "https://www.zhihu.com/favicon.ico",
    platformName: "知乎",
    injectUrl: "https://www.zhihu.com",
    injectFunction: async () => {},
    tags: ["CN"],
    accountKey: "zhihu",
  },
  DYNAMIC_INSTAGRAM: {
    type: "DYNAMIC",
    name: "DYNAMIC_INSTAGRAM",
    homeUrl: "https://www.instagram.com/",
    faviconUrl: "https://static.cdninstagram.com/rsrc.php/v3/yG/r/De-Dwpd5CHc.png",
    platformName: "Instagram",
    injectUrl: "https://www.instagram.com/",
    injectFunction: async () => {},
    tags: ["International"],
    accountKey: "instagram",
  },
  DYNAMIC_FACEBOOK: {
    type: "DYNAMIC",
    name: "DYNAMIC_FACEBOOK",
    homeUrl: "https://www.facebook.com/",
    faviconUrl: "https://static.xx.fbcdn.net/rsrc.php/yT/r/aGT3gskzWBf.ico",
    platformName: "Facebook",
    injectUrl: "https://www.facebook.com/",
    injectFunction: async () => {},
    tags: ["International"],
    accountKey: "facebook",
  },
  DYNAMIC_LINKEDIN: {
    type: "DYNAMIC",
    name: "DYNAMIC_LINKEDIN",
    homeUrl: "https://www.linkedin.com/",
    faviconUrl: "https://static.licdn.com/aero-v1/sc/h/eahiplrwoq61f4uan012ia17i",
    platformName: "LinkedIn",
    injectUrl: "https://www.linkedin.com/feed",
    injectFunction: async () => {},
    tags: ["International"],
    accountKey: "linkedin",
  },
  DYNAMIC_OKJIKE: {
    type: "DYNAMIC",
    name: "DYNAMIC_OKJIKE",
    homeUrl: "https://web.okjike.com",
    faviconUrl: "https://web.okjike.com/favicon.ico",
    platformName: "即刻",
    injectUrl: "https://web.okjike.com",
    injectFunction: async () => {},
    tags: ["CN"],
    accountKey: "okjike",
  },
  DYNAMIC_REDDIT: {
    type: "DYNAMIC",
    name: "DYNAMIC_REDDIT",
    homeUrl: "https://www.reddit.com/",
    faviconUrl: "https://www.reddit.com/favicon.ico",
    platformName: "Reddit",
    injectUrl: "https://www.reddit.com/submit?type=IMAGE",
    injectFunction: async () => {},
    tags: ["International"],
    accountKey: "reddit",
  },
  DYNAMIC_PINTEREST: {
    type: "DYNAMIC",
    name: "DYNAMIC_PINTEREST",
    homeUrl: "https://www.pinterest.com/",
    faviconUrl: "https://s.pinimg.com/webapp/favicon_48x48-7470a30d.png",
    platformName: "Pinterest",
    injectUrl: "https://www.pinterest.com/pin-creation-tool/",
    injectFunction: async () => {},
    tags: ["International"],
    accountKey: "pinterest",
  },
  DYNAMIC_KUAISHOU: {
    type: "DYNAMIC",
    name: "DYNAMIC_KUAISHOU",
    homeUrl: "https://cp.kuaishou.com/",
    faviconUrl: "https://www.kuaishou.com/favicon.ico",
    platformName: "快手",
    injectUrl: "https://cp.kuaishou.com/article/publish/video",
    injectFunction: async () => {},
    tags: ["CN"],
    accountKey: "kuaishou",
  },
  DYNAMIC_BAIJIAHAO: {
    type: "DYNAMIC",
    name: "DYNAMIC_BAIJIAHAO",
    homeUrl: "https://baijiahao.baidu.com/",
    faviconUrl: "https://pic.rmb.bdstatic.com/10e1e2b43c35577e1315f0f6aad6ba24.vnd.microsoft.icon",
    platformName: "百家号",
    injectUrl: "https://baijiahao.baidu.com/builder/rc/edit?type=events",
    injectFunction: async () => {},
    tags: ["CN"],
    accountKey: "baijiahao",
  },
  DYNAMIC_TOUTIAO: {
    type: "DYNAMIC",
    name: "DYNAMIC_TOUTIAO",
    homeUrl: "https://mp.toutiao.com/",
    faviconUrl: "https://sf1-cdn-tos.toutiaostatic.com/obj/ttfe/pgcfe/sz/mp_logo.png",
    platformName: "今日头条",
    injectUrl: "https://mp.toutiao.com/profile_v4/weitoutiao/publish",
    injectFunction: async () => {},
    tags: ["CN"],
    accountKey: "toutiao",
  },
  DYNAMIC_THREADS: {
    type: "DYNAMIC",
    name: "DYNAMIC_THREADS",
    homeUrl: "https://www.threads.net/web",
    faviconUrl: "https://static.cdninstagram.com/rsrc.php/ye/r/lEu8iVizmNW.ico",
    platformName: "Threads",
    injectUrl: "https://www.threads.net/web",
    injectFunction: async () => {},
    tags: ["International"],
    accountKey: "threads",
  },
  DYNAMIC_WEIXINCHANNEL: {
    type: "DYNAMIC",
    name: "DYNAMIC_WEIXINCHANNEL",
    homeUrl: "https://channels.weixin.qq.com/platform",
    faviconUrl: "https://res.wx.qq.com/t/wx_fed/finder/helper/finder-helper-web/res/favicon-v2.ico",
    platformName: "微信视频号",
    injectUrl: "https://channels.weixin.qq.com/platform/post/finderNewLifeCreate",
    injectFunction: async () => {},
    tags: ["CN"],
    accountKey: "weixinchannel",
  },
  DYNAMIC_BLUESKY: {
    type: "DYNAMIC",
    name: "DYNAMIC_BLUESKY",
    homeUrl: "https://bsky.app/",
    faviconUrl: "https://web-cdn.bsky.app/static/favicon-32x32.png",
    platformName: "Bluesky",
    injectUrl: "https://bsky.app/",
    injectFunction: async () => {},
    tags: ["International"],
    accountKey: "bluesky",
  },
  DYNAMIC_V2EX: {
    type: "DYNAMIC",
    name: "DYNAMIC_V2EX",
    homeUrl: "https://www.v2ex.com/",
    faviconUrl: "https://www.v2ex.com/favicon.ico",
    platformName: "V2EX",
    injectUrl: "https://www.v2ex.com/write",
    injectFunction: async () => {},
    tags: ["CN"],
    accountKey: "v2ex",
  },
  DYNAMIC_DOUBAN: {
    type: "DYNAMIC",
    name: "DYNAMIC_DOUBAN",
    homeUrl: "https://www.douban.com/",
    faviconUrl: "https://www.douban.com/favicon.ico",
    platformName: "豆瓣",
    injectUrl: "https://www.douban.com/",
    injectFunction: async () => {},
    tags: ["CN"],
    accountKey: "douban",
  },
  DYNAMIC_DEDAO: {
    type: "DYNAMIC",
    name: "DYNAMIC_DEDAO",
    homeUrl: "https://www.dedao.cn/",
    faviconUrl: "https://www.dedao.cn/favicon.ico",
    platformName: "得到",
    injectUrl: "https://www.dedao.cn/knowledge/home",
    injectFunction: async () => {},
    tags: ["CN"],
    accountKey: "dedao",
  },
  DYNAMIC_WEIXIN: {
    type: "DYNAMIC",
    name: "DYNAMIC_WEIXIN",
    homeUrl: "https://mp.weixin.qq.com/",
    faviconUrl: "https://mp.weixin.qq.com/favicon.ico",
    platformName: "微信公众号",
    injectUrl: "https://mp.weixin.qq.com/",
    injectFunction: async () => {},
    tags: ["CN"],
    accountKey: "weixin",
  },
  DYNAMIC_WEBHOOK: {
    type: "DYNAMIC",
    name: "DYNAMIC_WEBHOOK",
    homeUrl: "https://multipost.app/about/",
    faviconUrl: "https://multipost.app/favicon.ico",
    platformName: "Webhook",
    injectUrl: "https://multipost.app/about/",
    injectFunction: async () => {},
    tags: ["International"],
    accountKey: "webhook",
  },
  DYNAMIC_ZSXQ: {
    type: "DYNAMIC",
    name: "DYNAMIC_ZSXQ",
    homeUrl: "https://wx.zsxq.com/",
    faviconUrl: "https://wx.zsxq.com/assets_dweb/images/favicon_32.ico",
    platformName: "知识星球",
    injectUrl: "https://wx.zsxq.com/",
    injectFunction: async () => {},
    tags: ["CN"],
    accountKey: "zsxq",
  },
  DYNAMIC_XIAOHEIHE: {
    type: "DYNAMIC",
    name: "DYNAMIC_XIAOHEIHE",
    homeUrl: "https://www.xiaoheihe.cn/",
    faviconUrl: "https://www.xiaoheihe.cn/favicon.ico",
    platformName: "小黑盒",
    injectUrl: "https://www.xiaoheihe.cn/creator/editor/draft/image_text",
    injectFunction: async () => {},
    tags: ["CN"],
    accountKey: "xiaoheihe",
  },
  DYNAMIC_TOUTIAOHAO: {
    type: "DYNAMIC",
    name: "DYNAMIC_TOUTIAOHAO",
    homeUrl: "https://www.toutiao.com/",
    faviconUrl: "https://sf1-cdn-tos.toutiaostatic.com/obj/ttfe/pgcfe/sz/mp_logo.png",
    platformName: "头条号",
    injectUrl: "https://mp.toutiao.com/profile_v4/weitoutiao/publish",
    injectFunction: async () => {},
    tags: ["CN"],
    accountKey: "toutiaohao",
  },
  DYNAMIC_SUBSTACK: {
    type: "DYNAMIC",
    name: "DYNAMIC_SUBSTACK",
    homeUrl: "https://substack.com/",
    faviconUrl: "https://substack.com/favicon.ico",
    platformName: "Substack",
    injectUrl: "https://substack.com/home",
    injectFunction: async () => {},
    tags: ["International"],
    accountKey: "substack",
  },
  DYNAMIC_MAIMAI: {
    type: "DYNAMIC",
    name: "DYNAMIC_MAIMAI",
    homeUrl: "https://maimai.cn/",
    faviconUrl: "https://maimai.cn/favicon.ico",
    platformName: "脉脉",
    injectUrl: "https://maimai.cn/community/home/following",
    injectFunction: async () => {},
    tags: ["CN"],
    accountKey: "maimai",
  },
  DYNAMIC_JUEJIN: {
    type: "DYNAMIC",
    name: "DYNAMIC_JUEJIN",
    homeUrl: "https://juejin.cn/",
    faviconUrl: "https://juejin.cn/favicon.ico",
    platformName: "稀土掘金",
    injectUrl: "https://juejin.cn/pins",
    injectFunction: async () => {},
    tags: ["CN"],
    accountKey: "juejin",
  },

  // ========== ARTICLE PLATFORMS (40) ==========
  ARTICLE_ZHIHU: {
    type: "ARTICLE",
    name: "ARTICLE_ZHIHU",
    homeUrl: "https://zhuanlan.zhihu.com/",
    faviconUrl: "https://www.zhihu.com/favicon.ico",
    platformName: "知乎专栏",
    injectUrl: "https://zhuanlan.zhihu.com/write",
    injectFunction: async () => {},
    tags: ["CN"],
    accountKey: "zhihu",
  },
  ARTICLE_WEIBO: {
    type: "ARTICLE",
    name: "ARTICLE_WEIBO",
    homeUrl: "https://weibo.com",
    faviconUrl: "https://weibo.com/favicon.ico",
    platformName: "微博文章",
    injectUrl: "https://weibo.com",
    injectFunction: async () => {},
    tags: ["CN"],
    accountKey: "weibo",
  },
  ARTICLE_BILIBILI: {
    type: "ARTICLE",
    name: "ARTICLE_BILIBILI",
    homeUrl: "https://www.bilibili.com",
    faviconUrl: "https://static.hdslb.com/images/favicon.ico",
    platformName: "Bilibili 专栏",
    injectUrl: "https://member.bilibili.com/platform/upload/text/article",
    injectFunction: async () => {},
    tags: ["CN"],
    accountKey: "bilibili",
  },
  ARTICLE_MEDIUM: {
    type: "ARTICLE",
    name: "ARTICLE_MEDIUM",
    homeUrl: "https://medium.com",
    faviconUrl: "https://miro.medium.com/v2/1*m-R_BkNf1Qjr1YbyOIJY2w.png",
    platformName: "Medium",
    injectUrl: "https://medium.com/new-story",
    injectFunction: async () => {},
    tags: ["International"],
    accountKey: "medium",
  },
  ARTICLE_SUBSTACK: {
    type: "ARTICLE",
    name: "ARTICLE_SUBSTACK",
    homeUrl: "https://substack.com",
    faviconUrl: "https://substack.com/favicon.ico",
    platformName: "Substack",
    injectUrl: "https://substack.com/home",
    injectFunction: async () => {},
    tags: ["International"],
    accountKey: "substack",
  },
  ARTICLE_CSDN: {
    type: "ARTICLE",
    name: "ARTICLE_CSDN",
    homeUrl: "https://blog.csdn.net/",
    faviconUrl: "https://g.csdnimg.cn/static/logo/favicon32.ico",
    platformName: "CSDN",
    injectUrl: "https://editor.csdn.net/md",
    injectFunction: async () => {},
    tags: ["CN"],
    accountKey: "csdn",
  },
  ARTICLE_JUEJIN: {
    type: "ARTICLE",
    name: "ARTICLE_JUEJIN",
    homeUrl: "https://juejin.cn/",
    faviconUrl: "https://juejin.cn/favicon.ico",
    platformName: "稀土掘金",
    injectUrl: "https://juejin.cn/editor/drafts/new",
    injectFunction: async () => {},
    tags: ["CN"],
    accountKey: "juejin",
  },
  ARTICLE_JIANSHU: {
    type: "ARTICLE",
    name: "ARTICLE_JIANSHU",
    homeUrl: "https://www.jianshu.com/",
    faviconUrl: "https://www.jianshu.com/favicon.ico",
    platformName: "简书",
    injectUrl: "https://www.jianshu.com/writer",
    injectFunction: async () => {},
    tags: ["CN"],
    accountKey: "jianshu",
  },
  ARTICLE_TOUTIAO: {
    type: "ARTICLE",
    name: "ARTICLE_TOUTIAO",
    homeUrl: "https://mp.toutiao.com/",
    faviconUrl: "https://sf1-cdn-tos.toutiaostatic.com/obj/ttfe/pgcfe/sz/mp_logo.png",
    platformName: "头条号",
    injectUrl: "https://mp.toutiao.com/profile_v4/graphic/publish",
    injectFunction: async () => {},
    tags: ["CN"],
    accountKey: "toutiao",
  },
  ARTICLE_BAIJIAHAO: {
    type: "ARTICLE",
    name: "ARTICLE_BAIJIAHAO",
    homeUrl: "https://baijiahao.baidu.com/",
    faviconUrl: "https://pic.rmb.bdstatic.com/10e1e2b43c35577e1315f0f6aad6ba24.vnd.microsoft.icon",
    platformName: "百家号",
    injectUrl: "https://baijiahao.baidu.com/builder/rc/edit?type=news",
    injectFunction: async () => {},
    tags: ["CN"],
    accountKey: "baijiahao",
  },
  ARTICLE_SOHU: {
    type: "ARTICLE",
    name: "ARTICLE_SOHU",
    homeUrl: "https://mp.sohu.com/",
    faviconUrl: "https://statics.itc.cn/web/static/images/pic/sohu-logo/favicon.ico",
    platformName: "搜狐号",
    injectUrl: "https://mp.sohu.com/profile?param=article",
    injectFunction: async () => {},
    tags: ["CN"],
    accountKey: "sohu",
  },
  ARTICLE_NETEASE: {
    type: "ARTICLE",
    name: "ARTICLE_NETEASE",
    homeUrl: "https://mp.163.com/",
    faviconUrl: "https://mimg.127.net/p/news/logo/favicon.ico",
    platformName: "网易号",
    injectUrl: "https://mp.163.com/wemedia/article/publish",
    injectFunction: async () => {},
    tags: ["CN"],
    accountKey: "netease",
  },
  ARTICLE_SSPAI: {
    type: "ARTICLE",
    name: "ARTICLE_SSPAI",
    homeUrl: "https://sspai.com/",
    faviconUrl: "https://cdn.sspai.com/favicon/sspai-logo-32.png",
    platformName: "少数派",
    injectUrl: "https://sspai.com/write",
    injectFunction: async () => {},
    tags: ["CN"],
    accountKey: "sspai",
  },
  ARTICLE_OSCHINA: {
    type: "ARTICLE",
    name: "ARTICLE_OSCHINA",
    homeUrl: "https://www.oschina.net/",
    faviconUrl: "https://static.oschina.net/new-osc/img/favicon.ico",
    platformName: "开源中国",
    injectUrl: "https://www.oschina.net/blog/above",
    injectFunction: async () => {},
    tags: ["CN"],
    accountKey: "oschina",
  },
  ARTICLE_SEGMENTFAULT: {
    type: "ARTICLE",
    name: "ARTICLE_SEGMENTFAULT",
    homeUrl: "https://segmentfault.com/",
    faviconUrl: "https://static.segmentfault.com/main_site_next/0014a870/favicon.ico",
    platformName: "思否",
    injectUrl: "https://segmentfault.com/write",
    injectFunction: async () => {},
    tags: ["CN"],
    accountKey: "segmentfault",
  },
  ARTICLE_WEIXIN: {
    type: "ARTICLE",
    name: "ARTICLE_WEIXIN",
    homeUrl: "https://mp.weixin.qq.com/",
    faviconUrl: "https://mp.weixin.qq.com/favicon.ico",
    platformName: "微信公众号",
    injectUrl: "https://mp.weixin.qq.com/",
    injectFunction: async () => {},
    tags: ["CN"],
    accountKey: "weixin",
  },
  ARTICLE_DOUBAN: {
    type: "ARTICLE",
    name: "ARTICLE_DOUBAN",
    homeUrl: "https://www.douban.com/",
    faviconUrl: "https://www.douban.com/favicon.ico",
    platformName: "豆瓣日记",
    injectUrl: "https://www.douban.com/",
    injectFunction: async () => {},
    tags: ["CN"],
    accountKey: "douban",
  },
  ARTICLE_LOFTER: {
    type: "ARTICLE",
    name: "ARTICLE_LOFTER",
    homeUrl: "https://www.lofter.com/",
    faviconUrl: "https://www.lofter.com/favicon.ico",
    platformName: "LOFTER",
    injectUrl: "https://www.lofter.com/",
    injectFunction: async () => {},
    tags: ["CN"],
    accountKey: "lofter",
  },
  ARTICLE_TOUTIAOHAO: {
    type: "ARTICLE",
    name: "ARTICLE_TOUTIAOHAO",
    homeUrl: "https://www.toutiao.com/",
    faviconUrl: "https://sf1-cdn-tos.toutiaostatic.com/obj/ttfe/pgcfe/sz/mp_logo.png",
    platformName: "头条号",
    injectUrl: "https://mp.toutiao.com/profile_v4/graphic/publish",
    injectFunction: async () => {},
    tags: ["CN"],
    accountKey: "toutiaohao",
  },
  ARTICLE_WUCSONG: {
    type: "ARTICLE",
    name: "ARTICLE_WUCSONG",
    homeUrl: "https://wosong.cn/",
    faviconUrl: "https://wosong.cn/favicon.ico",
    platformName: "蜗牛博客",
    injectUrl: "https://wosong.cn/",
    injectFunction: async () => {},
    tags: ["CN"],
    accountKey: "wosong",
  },
  ARTICLE_HUGO: {
    type: "ARTICLE",
    name: "ARTICLE_HUGO",
    homeUrl: "https://hugo.pub/",
    faviconUrl: "https://hugo.pub/favicon.ico",
    platformName: "雨说博客",
    injectUrl: "https://hugo.pub/",
    injectFunction: async () => {},
    tags: ["CN"],
    accountKey: "hugo",
  },
  ARTICLE_GITHUB: {
    type: "ARTICLE",
    name: "ARTICLE_GITHUB",
    homeUrl: "https://github.com/",
    faviconUrl: "https://github.com/favicon.ico",
    platformName: "GitHub",
    injectUrl: "https://github.com/",
    injectFunction: async () => {},
    tags: ["International"],
    accountKey: "github",
  },
  ARTICLE_HASHNODE: {
    type: "ARTICLE",
    name: "ARTICLE_HASHNODE",
    homeUrl: "https://hashnode.com/",
    faviconUrl: "https://hashnode.com/favicon.ico",
    platformName: "Hashnode",
    injectUrl: "https://hashnode.com/",
    injectFunction: async () => {},
    tags: ["International"],
    accountKey: "hashnode",
  },
  ARTICLE_GHOST: {
    type: "ARTICLE",
    name: "ARTICLE_GHOST",
    homeUrl: "https://ghost.org/",
    faviconUrl: "https://ghost.org/favicon.ico",
    platformName: "Ghost",
    injectUrl: "https://ghost.org/",
    injectFunction: async () => {},
    tags: ["International"],
    accountKey: "ghost",
  },
  ARTICLE_NOTION: {
    type: "ARTICLE",
    name: "ARTICLE_NOTION",
    homeUrl: "https://www.notion.so/",
    faviconUrl: "https://www.notion.so/favicon.ico",
    platformName: "Notion",
    injectUrl: "https://www.notion.so/",
    injectFunction: async () => {},
    tags: ["International"],
    accountKey: "notion",
  },
  ARTICLE_TELEGRAM: {
    type: "ARTICLE",
    name: "ARTICLE_TELEGRAM",
    homeUrl: "https://web.telegram.org/",
    faviconUrl: "https://web.telegram.org/favicon.ico",
    platformName: "Telegram",
    injectUrl: "https://web.telegram.org/",
    injectFunction: async () => {},
    tags: ["International"],
    accountKey: "telegram",
  },

  // ========== VIDEO PLATFORMS (29) ==========
  VIDEO_BILIBILI: {
    type: "VIDEO",
    name: "VIDEO_BILIBILI",
    homeUrl: "https://www.bilibili.com",
    faviconUrl: "https://static.hdslb.com/images/favicon.ico",
    platformName: "Bilibili",
    injectUrl: "https://member.bilibili.com/platform/upload/video/frame",
    injectFunction: async () => {},
    tags: ["CN"],
    accountKey: "bilibili",
  },
  VIDEO_DOUYIN: {
    type: "VIDEO",
    name: "VIDEO_DOUYIN",
    homeUrl: "https://creator.douyin.com/",
    faviconUrl: "https://lf1-cdn-tos.bytegoofy.com/goofy/ies/douyin_web/public/favicon.ico",
    platformName: "抖音",
    injectUrl: "https://creator.douyin.com/creator-micro/content/upload",
    injectFunction: async () => {},
    tags: ["CN"],
    accountKey: "douyin",
  },
  VIDEO_YOUTUBE: {
    type: "VIDEO",
    name: "VIDEO_YOUTUBE",
    homeUrl: "https://www.youtube.com",
    faviconUrl: "https://www.youtube.com/favicon.ico",
    platformName: "YouTube",
    injectUrl: "https://studio.youtube.com",
    injectFunction: async () => {},
    tags: ["International"],
    accountKey: "youtube",
  },
  VIDEO_TIKTOK: {
    type: "VIDEO",
    name: "VIDEO_TIKTOK",
    homeUrl: "https://www.tiktok.com",
    faviconUrl: "https://www.tiktok.com/favicon.ico",
    platformName: "TikTok",
    injectUrl: "https://www.tiktok.com/creator",
    injectFunction: async () => {},
    tags: ["International"],
    accountKey: "tiktok",
  },
  VIDEO_KUAISHOU: {
    type: "VIDEO",
    name: "VIDEO_KUAISHOU",
    homeUrl: "https://cp.kuaishou.com/",
    faviconUrl: "https://www.kuaishou.com/favicon.ico",
    platformName: "快手",
    injectUrl: "https://cp.kuaishou.com/article/publish/video",
    injectFunction: async () => {},
    tags: ["CN"],
    accountKey: "kuaishou",
  },
  VIDEO_WEIBO: {
    type: "VIDEO",
    name: "VIDEO_WEIBO",
    homeUrl: "https://weibo.com",
    faviconUrl: "https://weibo.com/favicon.ico",
    platformName: "微博视频",
    injectUrl: "https://weibo.com",
    injectFunction: async () => {},
    tags: ["CN"],
    accountKey: "weibo",
  },
  VIDEO_REDNOTE: {
    type: "VIDEO",
    name: "VIDEO_REDNOTE",
    homeUrl: "https://creator.xiaohongshu.com/",
    faviconUrl: "https://fe-video-qc.xhscdn.com/fe-platform/ed8fe781ce9e16c1bfac2cd962f0721edabe2e49.ico",
    platformName: "小红书视频",
    injectUrl: "https://creator.xiaohongshu.com/publish/publish?target=video",
    injectFunction: async () => {},
    tags: ["CN"],
    accountKey: "rednote",
  },
  VIDEO_WEIXINCHANNEL: {
    type: "VIDEO",
    name: "VIDEO_WEIXINCHANNEL",
    homeUrl: "https://channels.weixin.qq.com/platform",
    faviconUrl: "https://res.wx.qq.com/t/wx_fed/finder/helper/finder-helper-web/res/favicon-v2.ico",
    platformName: "微信视频号",
    injectUrl: "https://channels.weixin.qq.com/platform/post/finderVideoPublish",
    injectFunction: async () => {},
    tags: ["CN"],
    accountKey: "weixinchannel",
  },
  VIDEO_XIAOHEIHE: {
    type: "VIDEO",
    name: "VIDEO_XIAOHEIHE",
    homeUrl: "https://www.xiaoheihe.cn/",
    faviconUrl: "https://www.xiaoheihe.cn/favicon.ico",
    platformName: "小黑盒",
    injectUrl: "https://www.xiaoheihe.cn/creator/editor/draft/video",
    injectFunction: async () => {},
    tags: ["CN"],
    accountKey: "xiaoheihe",
  },
  VIDEO_TOUTIAOHAO: {
    type: "VIDEO",
    name: "VIDEO_TOUTIAOHAO",
    homeUrl: "https://www.toutiao.com/",
    faviconUrl: "https://sf1-cdn-tos.toutiaostatic.com/obj/ttfe/pgcfe/sz/mp_logo.png",
    platformName: "头条号视频",
    injectUrl: "https://mp.toutiao.com/profile_v4/graphic/publish",
    injectFunction: async () => {},
    tags: ["CN"],
    accountKey: "toutiaohao",
  },
  VIDEO_X: {
    type: "VIDEO",
    name: "VIDEO_X",
    homeUrl: "https://x.com/home",
    faviconUrl: "https://x.com/favicon.ico",
    platformName: "X (Twitter)",
    injectUrl: "https://x.com/home",
    injectFunction: async () => {},
    tags: ["International"],
    accountKey: "x",
  },
  VIDEO_INSTAGRAM: {
    type: "VIDEO",
    name: "VIDEO_INSTAGRAM",
    homeUrl: "https://www.instagram.com/",
    faviconUrl: "https://static.cdninstagram.com/rsrc.php/v3/yG/r/De-Dwpd5CHc.png",
    platformName: "Instagram Reels",
    injectUrl: "https://www.instagram.com/",
    injectFunction: async () => {},
    tags: ["International"],
    accountKey: "instagram",
  },
  VIDEO_FACEBOOK: {
    type: "VIDEO",
    name: "VIDEO_FACEBOOK",
    homeUrl: "https://www.facebook.com/",
    faviconUrl: "https://static.xx.fbcdn.net/rsrc.php/yT/r/aGT3gskzWBf.ico",
    platformName: "Facebook",
    injectUrl: "https://www.facebook.com/",
    injectFunction: async () => {},
    tags: ["International"],
    accountKey: "facebook",
  },
  VIDEO_LINKEDIN: {
    type: "VIDEO",
    name: "VIDEO_LINKEDIN",
    homeUrl: "https://www.linkedin.com/",
    faviconUrl: "https://static.licdn.com/aero-v1/sc/h/eahiplrwoq61f4uan012ia17i",
    platformName: "LinkedIn",
    injectUrl: "https://www.linkedin.com/feed",
    injectFunction: async () => {},
    tags: ["International"],
    accountKey: "linkedin",
  },
  VIDEO_PINTEREST: {
    type: "VIDEO",
    name: "VIDEO_PINTEREST",
    homeUrl: "https://www.pinterest.com/",
    faviconUrl: "https://s.pinimg.com/webapp/favicon_48x48-7470a30d.png",
    platformName: "Pinterest",
    injectUrl: "https://www.pinterest.com/pin-creation-tool/",
    injectFunction: async () => {},
    tags: ["International"],
    accountKey: "pinterest",
  },
  VIDEO_SNAPCHAT: {
    type: "VIDEO",
    name: "VIDEO_SNAPCHAT",
    homeUrl: "https://www.snapchat.com/",
    faviconUrl: "https://www.snapchat.com/favicon.ico",
    platformName: "Snapchat",
    injectUrl: "https://www.snapchat.com/",
    injectFunction: async () => {},
    tags: ["International"],
    accountKey: "snapchat",
  },
  VIDEO_VIMEO: {
    type: "VIDEO",
    name: "VIDEO_VIMEO",
    homeUrl: "https://vimeo.com/",
    faviconUrl: "https://vimeo.com/favicon.ico",
    platformName: "Vimeo",
    injectUrl: "https://vimeo.com/",
    injectFunction: async () => {},
    tags: ["International"],
    accountKey: "vimeo",
  },
  VIDEO_DAILYMOTION: {
    type: "VIDEO",
    name: "VIDEO_DAILYMOTION",
    homeUrl: "https://www.dailymotion.com/",
    faviconUrl: "https://www.dailymotion.com/favicon.ico",
    platformName: "Dailymotion",
    injectUrl: "https://www.dailymotion.com/",
    injectFunction: async () => {},
    tags: ["International"],
    accountKey: "dailymotion",
  },
  VIDEO_TWITCH: {
    type: "VIDEO",
    name: "VIDEO_TWITCH",
    homeUrl: "https://www.twitch.tv/",
    faviconUrl: "https://www.twitch.tv/favicon.ico",
    platformName: "Twitch",
    injectUrl: "https://www.twitch.tv/",
    injectFunction: async () => {},
    tags: ["International"],
    accountKey: "twitch",
  },

  // ========== PODCAST PLATFORMS (7) ==========
  PODCAST_XIMALAYA: {
    type: "PODCAST",
    name: "PODCAST_XIMALAYA",
    homeUrl: "https://www.ximalaya.com",
    faviconUrl: "https://www.ximalaya.com/favicon.ico",
    platformName: "喜马拉雅",
    injectUrl: "https://www.ximalaya.com/zhubo/manage/track",
    injectFunction: async () => {},
    tags: ["CN"],
    accountKey: "ximalaya",
  },
  PODCAST_SPOTIFY: {
    type: "PODCAST",
    name: "PODCAST_SPOTIFY",
    homeUrl: "https://open.spotify.com",
    faviconUrl: "https://open.spotify.com/favicon.ico",
    platformName: "Spotify",
    injectUrl: "https://podcasters.spotify.com",
    injectFunction: async () => {},
    tags: ["International"],
    accountKey: "spotify",
  },
  PODCAST_NETEASE: {
    type: "PODCAST",
    name: "PODCAST_NETEASE",
    homeUrl: "https://music.163.com/",
    faviconUrl: "https://s1.music.126.net/style/favicon.ico",
    platformName: "网易云音乐",
    injectUrl: "https://music.163.com/",
    injectFunction: async () => {},
    tags: ["CN"],
    accountKey: "netease",
  },
  PODCAST_QQMUSIC: {
    type: "PODCAST",
    name: "PODCAST_QQMUSIC",
    homeUrl: "https://y.qq.com/",
    faviconUrl: "https://y.qq.com/favicon.ico",
    platformName: "QQ音乐",
    injectUrl: "https://y.qq.com/",
    injectFunction: async () => {},
    tags: ["CN"],
    accountKey: "qqmusic",
  },
  PODCAST_LIZHI: {
    type: "PODCAST",
    name: "PODCAST_LIZHI",
    homeUrl: "https://www.lizhi.fm/",
    faviconUrl: "https://www.lizhi.fm/favicon.ico",
    platformName: "荔枝FM",
    injectUrl: "https://www.lizhi.fm/",
    injectFunction: async () => {},
    tags: ["CN"],
    accountKey: "lizhi",
  },
  PODCAST_QINGTING: {
    type: "PODCAST",
    name: "PODCAST_QINGTING",
    homeUrl: "https://www.qingting.fm/",
    faviconUrl: "https://www.qingting.fm/favicon.ico",
    platformName: "蜻蜓FM",
    injectUrl: "https://www.qingting.fm/",
    injectFunction: async () => {},
    tags: ["CN"],
    accountKey: "qingting",
  },
  PODCAST_XIAOYUZHOU: {
    type: "PODCAST",
    name: "PODCAST_XIAOYUZHOU",
    homeUrl: "https://www.xiaoyuzhoufm.com/",
    faviconUrl: "https://www.xiaoyuzhoufm.com/favicon.ico",
    platformName: "小宇宙",
    injectUrl: "https://www.xiaoyuzhoufm.com/",
    injectFunction: async () => {},
    tags: ["CN"],
    accountKey: "xiaoyuzhou",
  },
}

// Helper functions
export function getPlatformsByType(type: "DYNAMIC" | "VIDEO" | "ARTICLE" | "PODCAST"): PlatformInfo[] {
  return Object.values(allPlatforms).filter(p => p.type === type)
}

export function getPlatformCountByType(): Record<string, number> {
  const counts = { DYNAMIC: 0, ARTICLE: 0, VIDEO: 0, PODCAST: 0, TOTAL: 0 }
  Object.values(allPlatforms).forEach(p => {
    counts[p.type]++
    counts.TOTAL++
  })
  return counts
}

export function getPlatformsByTag(tag: string): PlatformInfo[] {
  return Object.values(allPlatforms).filter(p => p.tags?.includes(tag))
}
